export const host = "https://us-central1-yeahnotes-a8414.cloudfunctions.net/app";

export const hostProd =
  "https://us-central1-yeahnotes-a8414.cloudfunctions.net/app";

export const hostLocal =
  "http://localhost:5000/yeahnotes-a8414/us-central1/app";

export const hostDevelop =
  "https://us-central1-yeahnotes-develop.cloudfunctions.net/app";